document.addEventListener('DOMContentLoaded', function () {
  const cartButton = document.querySelector('.js-drawer-open-cart');
  const cartDrawer = document.getElementById('CartDrawer');

  if (!cartButton || !cartDrawer) return;

  function updateAria() {
    const isOpen = cartDrawer.classList.contains('is-open');
    cartButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  const observer = new MutationObserver(updateAria);
  observer.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });

  updateAria();

  document.addEventListener('drawer:open', updateAria);
  document.addEventListener('drawer:close', updateAria);
});